
import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Link } from 'react-router-dom';
import { LanguageSwitcher } from '@/components/LanguageSwitcher';
import { useAuth } from '@/contexts/AuthContext';

export function Footer() {
  const { t } = useLanguage();
  const { isAuthenticated } = useAuth();
  
  // Don't render the footer if user is authenticated
  if (isAuthenticated) {
    return null;
  }
  
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="container px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand column */}
          <div className="space-y-2">
            <Link to="/" className="font-display text-lg font-bold flex">
              <img src="https://storage.googleapis.com/sportlogin/frontend/logo-blue.png" width="25"></img> SPORTLOGIN
            </Link>
            {/*<p className="text-muted-foreground">
              {t('footer.professional_platform')}
            </p>*/}
            <div className="flex items-center">
              <LanguageSwitcher />
              <span className="text-sm text-muted-foreground">{t('footer.change_language')}</span>
            </div>
          </div>
          
          {/* Quick links */}
          <div className='hidden'>
            <h3 className="font-medium text-lg mb-4">{t('footer.product')}</h3>
            <ul className="space-y-3">
              <li><Link to="/features" className="text-muted-foreground hover:text-foreground transition-colors">{t('nav.features')}</Link></li>
              <li><Link to="/pricing" className="text-muted-foreground hover:text-foreground transition-colors">{t('nav.pricing')}</Link></li>
              <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">{t('footer.integrations')}</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">{t('footer.customers')}</a></li>
            </ul>
          </div>
          
          {/* Resources */}
          <div className='hidden'>
            <h3 className="font-medium text-lg mb-4">{t('footer.resources')}</h3>
            <ul className="space-y-3">
              <li><Link to="/documentation" className="text-muted-foreground hover:text-foreground transition-colors">{t('nav.documentation')}</Link></li>
              <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">{t('footer.community')}</a></li>
              <li><Link to="/support" className="text-muted-foreground hover:text-foreground transition-colors">{t('nav.support')}</Link></li>
            </ul>
          </div>
          
          {/* Company */}
          <div className='hidden'>
            <h3 className="font-medium text-lg mb-4">{t('footer.company')}</h3>
            <ul className="space-y-3">
              <li><Link to="/support" className="text-muted-foreground hover:text-foreground transition-colors">{t('nav.support')}</Link></li>
              <li><Link to="/about" className="text-muted-foreground hover:text-foreground transition-colors">{t('nav.about')}</Link></li>
              <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">{t('footer.careers')}</a></li>
              <li><Link to="/contact" className="text-muted-foreground hover:text-foreground transition-colors">{t('nav.contact')}</Link></li>
              <li><Link to="/legal" className="text-muted-foreground hover:text-foreground transition-colors">{t('nav.legal')}</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-200 mt-12 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-muted-foreground">
            © 2025 SPORTLOGIN. {t('common.allRightsReserved')}.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/legal" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              {t('footer.terms')}
            </Link>
            <Link to="/legal?tab=privacy" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              {t('footer.privacy')}
            </Link>
            <Link to="/support" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              {t('nav.support')}
            </Link>
            {/* Removed My Account link */}
          </div>
        </div>
      </div>
    </footer>
  );
}
